import React, { useState } from 'react';

import { BoxContainer, Breadcrumb, Typography } from '../../components';
import { URLS } from '../../utils';
import { PaginationData } from '../../utils/types';
import TrucksReportsTable from './components/TrucksReportsTable';
import useTrucksReports from './hooks/useTrucksReports';

const PageContent = () => {
  const breadcrumbItems = [
    { location: URLS.dashboard, name: 'Dashboard' },
    {
      location: URLS.reportTrucks,
      name: 'Reporte de Camiones',
      withUserRole: true,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const paginationData: PaginationData = {
    pageSize: 8,
    current: currentPage,
  };

  const {
    isLoading,
    data,
    totalResults,
    tableFilters,
    setTransportQuery,
    transportOptions,
    generateReportPDF,
    generateReportXLXS,
  } = useTrucksReports({
    paginationData,
  });

  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <Breadcrumb items={breadcrumbItems} />
      <Typography theme="h1" $marginBottom="2rem">
        Reporte de Camiones
      </Typography>
      <TrucksReportsTable
        data={data}
        isLoading={isLoading}
        onFilter={tableFilters}
        transportFilterOptions={transportOptions}
        transportFilterQuery={setTransportQuery}
        paginationData={{
          ...paginationData,
          onChange: setCurrentPage,
          total: totalResults,
        }}
        onGenerateReportPDF={generateReportPDF}
        onGenerateReportXLXS={generateReportXLXS}
      />
    </BoxContainer>
  );
};

export default PageContent;
